import { RouterType } from '@online-webinar/router';
import { ListWebinars } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/organized/$tab'].update({
        staticData: { title: { page: { param: 'tab', keys: { upcoming: 'Title.OrganizedUpcoming', ended: 'Title.OrganizedEnded' } } } },
        component: authGuard(ListWebinars, { canBroadcast: true })
    });
};
